
import React from 'react';

interface IProps {
  style?: any;  
  strokeWidth?: number;
  rounded?:boolean;
}

export const LineIcon:React.FC<IProps> = (props: IProps) => {

  let width = 210;
  let height=props.strokeWidth??1;  
  let x1= 0;
  let y1= height/2;
  let x2 = width;
  let y2= y1; 

  if (props.rounded)
  {
    x1= height/2;
    x2 = width - x1;
  }

  let viewBox= "0 0 "+width.toString() + " "+height.toString();  
  return (
        <svg width={width.toString()} height={height.toString()} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
        <line x1={x1.toString()} y1={y1.toString()} x2={x2.toString()} y2={y2.toString()} stroke="#dee2eb" strokeWidth={props.strokeWidth?.toString()} 
          strokeLinecap={props.rounded ? "round" : undefined}/>
        </svg>
        
  )
}

export const VerticalLineIcon:React.FC<IProps> = (props: IProps) => {

  let height = 158;
  let width=props.strokeWidth??1;  

  let x=0;
  let x1=height;
  if (props.rounded)
  {
    x= width/2; 
    x1= height-x;   
  }
  let d= "M"+x.toString()+" "+x1.toString()+"V"+x.toString();  
  return (
        <svg width={width.toString()} height={height.toString()}  fill="none" xmlns="http://www.w3.org/2000/svg">
          <path stroke="#DEE2EB" d={d} strokeWidth={props.strokeWidth?.toString()}
            strokeLinecap={props.rounded ? "round" : undefined}/>
        </svg>
        
  )
}